import React from 'react'
import ActivityTypes from './stages/ActivityTypes'
import ActivityRange from './stages/ActivityRange'
import ActivityOverride from './stages/ActivityOverride'
import { DividerHorizontal } from '../../shared/DividerHorizontal'

import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'
import ActivityListChange from './stages/ActivityListChange'



const AddActivitiesForm = ({
  activitiesToEdit,
}: {
  activitiesToEdit?: any[]
}) => {
  const { t } = useLocalize()

  return (
    <div className="tw-flex tw-flex-col tw-gap-4  tw-p-6">
      {activitiesToEdit ? (
       <ActivityListChange activitiesToEdit={activitiesToEdit}/>
      ) : (
        <>
          <ActivityRange />
          <DividerHorizontal />
        </>
      )}
      <ActivityTypes />
      <>
        <DividerHorizontal />
        <ActivityOverride />
      </>
    </div>
  )
}

export default AddActivitiesForm
